export interface CourtDto {
  Court_guid: string;
  Court_Email: string;
  Court_Address: string;
  Court_Name: string;
  Court_Phone?: string;
  Court_Fax?: string;
  Court_County?: string | null;
  Court_OffersOffDocket?: boolean | null;
  Court_OfRecord?: boolean | null;
  /**
   * How this court takes a filing, and where. Optional on the type because an older API returns
   * neither, and a court page that crashes on a stale server is the fault this rule exists for.
   */
  Court_FilingMethod?: CourtFilingMethod | null;
  Court_FilingAddress?: string | null;
  Court_FilingNote?: string | null;
  Court_Active: boolean;
}

/**
 * How a court takes a filing. Mirrors `CourtFilingMethod` in
 * backend/src/utils/courts/courtFilingMethod.ts, which is the list the API validates against.
 * Change one and change the other, or the dropdown offers a value the server rejects.
 */
export type CourtFilingMethod = 'email' | 'website' | 'fax' | 'mail';

export const COURT_FILING_METHOD_LABELS: Record<CourtFilingMethod, string> = {
  email: 'Email',
  website: 'On the court’s website',
  fax: 'Fax',
  mail: 'Post',
};

export interface ProsecutorDto {
  Prosecutor_guid: string;
  Prosecutor_Email: string;
  Prosecutor_Name: string;
  Prosecutor_Phone?: string | null;
  Prosecutor_Disposition?: string | null;
  Prosecutor_Active: boolean;
}

export interface FullCourtDto extends CourtDto {
  prosecutors: ProsecutorDto[];
}

export interface CreateCourtDto {
  Court_Email: string;
  Court_Address: string;
  Court_Name: string;
  Court_Phone?: string;
  Court_Fax?: string;
  Court_Active: boolean;
}

export interface CreateProsecutorDto {
  Prosecutor_Email: string;
  Prosecutor_Name: string;
  Prosecutor_Phone?: string | null;
  Court_guid: string;
  Prosecutor_Active: boolean;
}

export interface FullProsecutorDto extends ProsecutorDto {
  court?: {
    Court_guid: string;
    Court_Name: string;
    Court_Email: string;
    Court_Address: string;
    Court_Phone?: string;
    Court_Fax?: string;
  };
}

export interface SearchFilters {
  Court_Name: string;
  Court_Address: string;
  Court_Email: string;
  Court_Phone: string;
  Court_Fax: string;
  search: string;
}
